<template>
  <div v-if="label" class="inline-block custom-tag">
    <el-tag size="mini" :type="value">
      {{ label }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.custom-tag {
  .el-tag--N {
    color: #409eff;
    border-color: #007bff;
    background-color: #ffffff;
  }
  .el-tag--Y {
    color: #67c23a;
    border-color: #28a745;
    background-color: #ffffff;
  }
  .el-tag--D {
    color: #f56c6c;
    border-color: #fa5c7c;
    background-color: #ffffff;
  }
}
</style>
